import { ISOString, ContactStage } from "@types";

export type Activity = StageChangeActivity | NoteActivity;
export enum ActivityType {
  Note = "Note",
  StageChanged = "Stage Changed",
}

export interface BaseActivity {
  id: number;
  created: ISOString;
  lead: {
    id: number;
    firstName: string;
    lastName: string;
  };
  occursAt: ISOString | null;
}
export interface NoteActivity extends BaseActivity {
  data: { note: string };
  type: ActivityType.Note;
}

export interface StageChangeActivity extends BaseActivity {
  data: { from: ContactStage; to: ContactStage };
  type: ActivityType.StageChanged;
}
